<div class="client-sites">
  <div class="action-row justify-end client-sites__head">
    <div class="form-check client-sites__toggle">
      <input
        class="form-check-input"
        id="showDeactivatedAdmin"
        type="checkbox"
        (change)="onShowDeactivatedSitesChange()"
        [checked]="showDeactivated"
      />
      <label class="form-check-label" for="showDeactivatedAdmin">
        Show deactivated
      </label>
    </div>
    <button
      type="button"
      class="btn btn-outline btn-sm"
      (click)="getUploadTemplate()"
    >
      <i class="bi bi-download me-1"></i>
      Download template
    </button>
    <button
      type="button"
      class="btn btn-primary btn-sm"
      (click)="uploadSites()"
    >
      <i class="bi bi-upload me-1"></i>
      Upload sites
    </button>
  </div>

  <div class="client-sites__grid">
    <app-sites-grid
      [gridName]="'ClientSites'"
      [ColumnIdToColumnActions]="ColumnIdToColumnActions"
      [suppliedQueryData]="SuppliedGridQuery"
      (actionEvent)="action($event)"
      [(reloadGridData)]="reloadGrid"
    ></app-sites-grid>
  </div>
</div>
